import { LogOut, Menu } from 'lucide-react';
import { useAuthStore } from '../store/authStore.js';

export default function AdminTopBar({ onMenuClick }) {
  const user = useAuthStore((s) => s.user);
  const logout = useAuthStore((s) => s.logout);

  const displayName = user?.nombre?.trim() || user?.email || 'Usuario';

  function handleLogout() {
    logout();
    window.location.href = '/admin/login';
  }

  return (
    <header className="sticky top-0 z-30 flex items-center justify-between gap-4 border-b border-slate-200 bg-white px-4 py-3 shadow-sm lg:px-8">
      <div className="flex min-w-0 items-center gap-3">
        <button
          type="button"
          className="rounded-lg p-2 text-slate-700 hover:bg-slate-100 lg:hidden"
          onClick={onMenuClick}
          aria-label="Abrir menú"
        >
          <Menu className="h-6 w-6" />
        </button>
        <span className="hidden font-display text-sm font-semibold text-accent-blue sm:inline lg:text-base">
          Panel administrativo
        </span>
      </div>

      <div className="flex min-w-0 items-center gap-2 sm:gap-4">
        <div className="min-w-0 text-right">
          <p className="truncate text-sm font-medium text-slate-800">{displayName}</p>
          {user?.nombre && user?.email ? (
            <p className="hidden truncate text-xs text-slate-500 sm:block">{user.email}</p>
          ) : null}
        </div>
        <button
          type="button"
          onClick={handleLogout}
          className="inline-flex shrink-0 items-center gap-2 rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-sm font-medium text-slate-700 transition hover:border-red-200 hover:bg-red-50 hover:text-red-700"
        >
          <LogOut className="h-4 w-4" aria-hidden />
          <span className="hidden sm:inline">Salir</span>
        </button>
      </div>
    </header>
  );
}
